module.exports = __webpack_public_path__ + "img/disabled-restrict-icon.576c9e5e.svg";